import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
import { Star } from '@music-vine/cadence/icons';
const _Pricing = (props: React.SVGProps<SVGSVGElement>) => <Star {...props} className={cn('size-4', props.className)} data-sentry-element="Star" data-sentry-component="_Pricing" data-sentry-source-file="Pricing.tsx" />;
const Pricing = memo(_Pricing);
export const PricingWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="PricingWithIconTag" data-sentry-source-file="Pricing.tsx">
    <Pricing className={className} data-sentry-element="Pricing" data-sentry-source-file="Pricing.tsx" />
  </i>;
export default Pricing;